module.exports = __webpack_public_path__ + "static/media/deutschlandkarte-v01.7994a106.svg";